import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import { putApi } from "../../../../services/api/globalApi";
import Button from "../../button/Button";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import * as XLSX from "xlsx";

const { forwardRef, useRef, useImperativeHandle } = React;

const ConfirmModal = forwardRef(({ orderData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const handleExel = () => {
    const newData = [];
    for (let i = 0; i < orderData?.length; i++) {
      newData.push({
        آیدی: orderData[i]?._id,
        "شماره سفارش": orderData[i]?.trackingCode,
      });
    }
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(newData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
    setShowModal(false);
  };

  const formHandler = async (print) => {
    const orderIds = orderData?.map((item) => {
      return item?._id;
    });
    const body = {
      ids: orderIds,
    };
    try {
      const path = `admin/orders/proccessShippingToExported/multiple`;
      await putApi({ path, body });
      successMessage("سفارشات با موفقیت تایید شدند");
      handleExel(orderIds);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>تایید سفارش</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="w-11/12 mx-auto py-8 text-center w-full">
          آیا شما این{orderData?.length} سفارش رو تایید میکنید؟
        </div>
        <div className="flex gap-2 justify-end w-full">
          <Button
            onClick={() => setShowModal(false)}
            text={"بازگشت"}
            color={"primary"}
            type="button"
          />
          <Button
            onClick={() => formHandler(false)}
            text={"تایید سفارش"}
            color={"success"}
          />
        </div>
      </div>
    </>
  );
});
export default ConfirmModal;
